export const FETCHING_AGENT = 'FETCHING_AGENT';
export const SEARCHING_AGENT = 'SEARCHING_AGENT';